import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !["/auth/login", "/auth/refresh", "/auth/me"].includes(cfg.url)) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Bir hata oluştu, lütfen tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const SYM = { TRY: "₺", USD: "$", EUR: "€" };
const nf = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const qf = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3 });
export const money = (v, cur = "TRY") => `${nf.format(v || 0)} ${SYM[cur] || cur}`;
export const num = (v) => nf.format(v || 0);
export const qty = (v) => qf.format(v || 0);
export const fmtDate = (s) => (s ? s.slice(0, 10).split("-").reverse().join(".") : "-");
export const fmtDateTime = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? fmtDate(s) : d.toLocaleString("tr-TR", { timeZone: "Europe/Istanbul", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
export const todayStr = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });
export const addDays = (s, n) => {
  const d = new Date(`${s}T12:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
export const monthStart = () => `${todayStr().slice(0, 8)}01`;

export const L = {
  accType: { customer: "Müşteri", supplier: "Tedarikçi", both: "Müşteri / Tedarikçi" },
  kind: { sale: "Satış", purchase: "Alış" },
  status: { pending: "Bekliyor", approved: "Onaylandı", partial: "Kısmi Sevk", shipped: "Sevk Edildi", closed: "Kapatıldı", invoiced: "Faturalandı", cancelled: "İptal" },
  method: { cash: "Nakit", bank: "Banka / Havale", card: "Kredi Kartı", check: "Çek / Senet" },
  payKind: { collection: "Tahsilat", payment: "Ödeme" },
  accMove: {
    opening: "Açılış", sale_invoice: "Satış Faturası", purchase_invoice: "Alış Faturası",
    collection: "Tahsilat", payment: "Ödeme",
  },
  stockMove: { opening: "Açılış", sale: "Satış", purchase: "Alış", adjust_in: "Manuel Giriş", adjust_out: "Manuel Çıkış", shipment: "Sevk", receipt: "Mal Kabul" },
};

export const VAT_RATES = [0, 1, 10, 20];
export const UNITS = ["Adet", "Kutu", "Paket", "Set", "Kg", "Gr", "Lt", "Metre", "m²", "Çift", "Kova", "Koli"];

export function downloadCSV(filename, columns, rows) {
  const esc = (v, c) => { let s = String(v ?? ""); if (c.type !== "money" && c.type !== "number" && /^[=+\-@\t\r]/.test(s)) s = `'${s}`; return `"${s.replace(/"/g, '""')}"`; };
  const fmt = (c, v) => (c.type === "money" || c.type === "number" ? String(v ?? 0).replace(".", ",") : c.type === "date" ? fmtDate(v) : v);
  const lines = [columns.map((c) => esc(c.label, c)).join(";"), ...rows.map((r) => columns.map((c) => esc(fmt(c, r[c.key]), c)).join(";"))];
  const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
